<template>
  <AwlTable :heading="tableHeadings" :rows="tableRows" striped class="investimenti-list-table">
    <template #column-key-importo="{ value }">
      {{ value | money }}
    </template>

    <template #column-key-vat="{ value }">
      {{ value }}%
    </template>

    <template v-if="editEnabled" #actions-content="{ row }">
      <ActionEdit class="mr-0 mr-md-2" :to="{ name: 'operative-company.data-analysis.investimenti.edit', params: { investimentoId: row.id } }" />
      <ActionDelete @click="remove(row.id)" />
    </template>
  </AwlTable>
</template>

<script>

import formatMoneyFilter from '../../../../filters/formatMoney';

export default {
  name: 'investimenti-list-table',
  components: {
    AwlTable: () => import('../../../../libs/Table/components/AwlTable'),
    ActionDelete: () => import('../../Actions/ActionDelete'),
    ActionEdit: () => import('../../Actions/ActionEdit'),
  },
  filters: {
    money: formatMoneyFilter,
  },
  props: {
    investimenti: {
      type: Array,
      default: () => [],
    },
    editEnabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    tableHeadings () {
      return [
        { key: 'name', label: 'Nome' },
        { key: 'importo', label: 'Importo' },

        { key: 'begin', label: 'Mese investimento' },
        { key: 'nbMesiAmmortamento', label: 'Mesi di ammortamento' },
        { key: 'tipoAmmortamentoFiscaleName', label: 'Ammortamento fiscale' },

        { key: 'vat', label: 'Iva' },
      ];
    },
    tableRows () {
      return (this.investimenti || []).map(r => {
        return r;
      });
    },
  },
  methods: {
    remove (id) {
      if (!this.editEnabled) {
        return;
      }

      this.$emit('delete', id);
    },
  },
};

</script>
